/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Actions_DeleteInputs */

const es_feedback_actions_delete = /** @type {(inputs: Feedback_Actions_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar feedback`)
};

const en_feedback_actions_delete = /** @type {(inputs: Feedback_Actions_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete feedback`)
};

/**
* | output |
* | --- |
* | "Delete feedback" |
*
* @param {Feedback_Actions_DeleteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_actions_delete = /** @type {((inputs?: Feedback_Actions_DeleteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Actions_DeleteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_actions_delete(inputs)
	return en_feedback_actions_delete(inputs)
});
export { feedback_actions_delete as "feedback.actions.delete" }